export const maxLayoutWidth = '1080px';

export const smallMargin = '8px';
export const normalMargin = '24px';
export const largeMargin = '40px';

export const largeBreakpoint = '769px';



// WEBPACK FOOTER //
// ./src/utils/layout-units.js